import MobileSearchFunctionalityLogicComponent from "@/components/search/partials/MobileSearchFunctionalityLogicComponent";
import Utils from "@/core/utils";
import IconComponent from "@/components/global/IconComponent.vue";

const data = () => {
    return {
        store: $store,
        currentLocationError: false,
        unSubscribe: null,
        searchElement: null,
        hasLoadedMobileFunctionality: false,
        searchMinimumInputLength: 2,
        hideDistanceOnMobile: false
    }
};

function mounted() {
    this.hideDistanceOnMobile = this.noDistanceOnMobile !== undefined ? this.noDistanceOnMobile : false;
    this.searchElement = $('#' + this.searchVariant);
    this.closeSelect2();
    this.bindSelect2ToStore();
    this.initSelect2();
}

function closeSelect2() {
    this.searchElement.trigger('select2:close');
}

function bindSelect2ToStore() {
    this.unSubscribe = this.store.subscribe((mutation) => {
        if (mutation.type === 'setFilterOpened' && mutation.payload) {
            this.currentLocationError = false;
            this.store.commit('setLocationTemp', _.cloneDeep(this.location));
        }
    });
}

function fillResults(retArr, data, key, categoryName, additional = {}) {
    retArr.push({
        id: null,
        type: 'category',
        text: categoryName,
    });

    _.each(data, (result) => {
        retArr.push({
            // objectID is not used but if it's "1" then select 2 won't trigger selection event
            id: result.objectID ? +result.objectID + 10000000 : result.id,
            text: _.isFunction(key) ? key(result) : result[key],
            result: result,
            ...additional
        })
    });

    retArr.push({
        id: null,
        type: 'hr',
        text: '',
    });
}

function initSelect2() {

    this.hasLoadedMobileFunctionality = false;

    this.searchElement.select2({
        forceDropdownPosition: 'below',
        ajax: {
            debug: true,
            url: process.env.MIX_API_URL + '/v1/search/location',
            delay: 500,
            cache: true,
            processResults: (data) => {
                const retArr = [];

                if (_.get($('.select2-search__field').val(), 'length', 0) < this.searchMinimumInputLength) {
                    this.$nextTick(this.clearSearch);
                    return {results: []};
                }

                if (_.isNaN(_.toNumber($('.select2-search__field').val()))) {
                    if (data.locations && data.locations.length) {
                        this.fillResults(retArr, data.locations, this.extractText, this.translate.home.location);
                    }

                    if (data.users && data.users.length) {
                        this.fillResults(retArr, data.users, 'username', this.translate.home.username, {profile: true, type: 'user'});
                    }

                    if (data.postcodes && data.postcodes.length) {
                        this.fillResults(retArr, data.postcodes, 'display_name', this.translate.home.postcode, {postcode: true});
                    }

                    if (data.locations2 && data.locations2.length) {
                        this.fillResults(retArr, data.locations2, this.extractText, this.translate.home.otherLocations);
                    }
                } else {
                    if (data.postcodes && data.postcodes.length) {
                        this.fillResults(retArr, data.postcodes, 'display_name', this.translate.home.postcode, {postcode: true});
                    }

                    if (data.users && data.users.length) {
                        this.fillResults(retArr, data.users, 'username', this.translate.home.username, {profile: true});
                    }

                    if (data.locations && data.locations.length) {
                        this.fillResults(retArr, data.locations, this.extractText, this.translate.home.location);
                    }

                    if (data.locations2 && data.locations2.length) {
                        this.fillResults(retArr, data.locations2, this.extractText, this.translate.home.otherLocations);
                    }
                }

                this.$nextTick(() => {
                    $('.select2-results__option').on('mouseover', (e) => {
                        if (e.bubbles) {
                            e.stopPropagation();
                        }
                    });
                });

                return {results: retArr};
            },
        },
        language: {
            inputTooShort: () => {
                return this.translate.home.searchInputTooShort;
            },
            searching: () => {
                return this.translate.home.searchSearching;
            },
            noResults: () => {
                return this.translate.home.searchNoResults;
            }
        },
        escapeMarkup: function (markup) {
            return markup;
        },
        placeholder: this.translate.home.searchPlaceholder,
        minimumInputLength: this.searchMinimumInputLength,
        templateResult: (state) => {
            switch (state.type) {
                case 'hr':
                    return $(
                        "<div class='select2-result-repository clearfix select2-hr'>" +
                        "<hr>" +
                        "</div>"
                    );
                case 'category':
                    return $(
                        "<div class='select2-result-repository clearfix select2-category-title'>" +
                        state.text +
                        "</div>"
                    );
                case 'user':
                    const userCity = state.result.city;
                    const citySpan = userCity ? `<span><icon-component :icon="fa_map_pin()"></icon-component> ${userCity}</span>` : '';

                    return $(
                        "<div class='select2-user'>" + state.text + citySpan + "</div>"
                    );
                default:
                    return state.text;
            }
        },
    });

    this.searchElement.on('select2:select', e => {
        const isProfile = _.get(e, 'params.data.profile', false);

        if (isProfile) {
            this.$router.push({path: _.get(e, 'params.data.result.profile_path')});
        } else {
            this.currentLocationError = false;
            this.onLocationChange(e);
        }

    });

    this.searchElement.on('select2:blur', this.closeSelect2);

    this.searchElement.on('select2:open', (e) => {

        $('.select2-container').addClass(this.searchVariant);

        $('input.select2-search__field').prop('placeholder', this.translate.home.searchPlaceholder);

        $('.search-back-button').off('click').on('click', () => {
            this.initSelect2();
            this.closeSelect2();
        });

        this.setSearchElementHeight();

        this.mobileFunctionalityLogic();

        if (this.searchVariant === 'searchMain') {
            this.$emit('onSearchClick');
        }

        const myLocationOption = this.createMyLocationField();
        $('.select2-results:not(:has(a))').append(myLocationOption.html);

        $('.my-location-' + this.searchVariant).unbind('click').bind('click', () => {
            this.onMyLocationSelected();
        });

        $('.select2-results__options').unbind('touchstart').bind('touchstart', () => {
            $('.select2-search__field').blur();
        });

        if (Utils.isMobile()) {
            window.history.pushState({}, '');
            window.isLocationModalActive = true;
        }
    });
}

function extractText(result) {
    if (_.get(result, 'isCurrentLocation', false)) {
        return _.get(this, 'translate.home.currentLocation');
    }

    if (_.get(result, 'display_name', false)) {
        return result.display_name;
    }

    return _.join(_.compact([
        _.get(result, 'locale_names[0]', false),
        _.get(result, 'county.[0]', false),
        _.get(result, 'administrative.[0]', false),
        _.get(result, 'city.[0]', false)
    ]), ', ');
}

function createMyLocationField() {
    return {
        id: 'myLocation',
        text: _.get(this, 'translate.home.currentLocation'),
        html: '<a class="search-my-location my-location-' + this.searchVariant + '"> '
            + this.translate.home.myLocation + `<icon-component :icon="fa_location_circle()"></icon-component>`
            + '</a>',
        result: null
    }
}

function onMyLocationSelected() {
    if (_.get(navigator, 'geolocation', false)) {
        this.getCurrentLocation();
    } else {
        this.currentLocationError = true;
        this.recoverFromLocationError();
    }
}

function getCurrentLocation(emitSearch = false) {
    navigator.geolocation.getCurrentPosition(
        position => {
            const payload = this.buildCurrentLocationPayload(position);
            this.store.commit('setLocation', payload);

            if (!!this.fromMain) {
                this.store.commit('refreshSearch', true);
            }

            this.currentLocationError = false;
            this.refreshSearchField();

            if (emitSearch) {
                this.$emit('search');
            }
        },
        positionError => {
            this.currentLocationError = true;
            this.recoverFromLocationError();
        },
        {enableHighAccuracy: true}
    );
}

function goToCurrentLocation(e) {
    navigator.geolocation.getCurrentPosition(
        position => {
            const payload = this.buildCurrentLocationPayload(position);
            this.store.commit('setLocation', payload);
            this.currentLocationError = false;
            this.refreshSearchField();
        },
        positionError => {
            this.currentLocationError = true;
            this.recoverFromLocationError();
        },
        {enableHighAccuracy: true}
    );
}

function refreshSearchField() {
    const myLocationOption = this.createMyLocationField();
    const newOption = new Option(myLocationOption.text, myLocationOption.id, true, true);

    this.initSelect2();
    this.searchElement.append(newOption).trigger('change');
    this.closeSelect2();
}

function recoverFromLocationError() {
    this.initSelect2();
    this.closeSelect2();
    switch (this.searchVariant) {
        case 'searchHome':
        case 'searchMain':
            $('#select2-' + this.searchVariant + '-container').text(this.location.query);
            break;
        default:
            $('#select2-' + this.searchVariant + '-container').text(this.locationTemp.query);
            break;
    }
}

function buildCurrentLocationPayload(position) {
    return {
        geo_point: {
            lat: _.get(position, 'coords.latitude', ''),
            lon: _.get(position, 'coords.longitude', ''),
        },
        is_city: false,
        locale_name: _.get(this, 'translate.home.currentLocation'),
        isCurrentLocation: true,
        fromMain: !!this.fromMain,
    };
}

function buildLocationPayload(result) {
    return {
        // Area autocomplete items carry the stable area id (geocoder items don't);
        // the backend resolves the area by id — areas.slug is dropped.
        id: _.get(result, 'id', null),
        geo_point: {
            lat: _.get(result, '_geoloc.lat', 0),
            lon: _.get(result, '_geoloc.lng', 0),
        },
        is_city: result.is_city || result.is_country || result.is_suburb || false,
        locale_name: _.get(result, 'locale_names.0', ''),
        display_name: _.get(result, 'display_name', null),
        slug: _.get(result, 'slug', null),
        county: _.get(result, 'county.0', ''),
        administrative: _.get(result, 'administrative.0', ''),
        city: _.get(result, 'city.0', ''),
        postcode: _.isString(_.get(result, 'postcode', '')) ? _.get(result, 'postcode', '') : '',
        fromMain: !!this.fromMain,
    };
}

function mobileFunctionalityLogic() {

    const isMobile = $(window).width() <= 576;

    if (!isMobile) {
        return;
    }

    if (!this.hasLoadedMobileFunctionality) {
        this.hasLoadedMobileFunctionality = true;
        this.mountMobileLogicComponentToSearch();
    }

    this.setSearchInputTextOnMobile();
}

function mountMobileLogicComponentToSearch() {

    // Mounting components dynamically cause errors in tests
    if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'testing') {
        return;
    }

    $('.select2-search').append('<span id="mobile-search-functionality-logic-component-placeholder"></span>');

    const MobileSearchFunctionalityLogic = Vue.extend(MobileSearchFunctionalityLogicComponent);
    const vm = new MobileSearchFunctionalityLogic({
        store: $store,
        propsData: {searchElement: this.searchElement, hideDistanceOnMobile: this.hideDistanceOnMobile}
    })
        .$mount('#mobile-search-functionality-logic-component-placeholder');
}

function setSearchInputTextOnMobile() {
    const locationText = _.get(this, 'location.query', _.get(this, 'location.display_name'));
    $('.select2-search__field').val(locationText);
}

function clearSearch() {
    $('.select2-search__field').val('').get(0).focus();
    $('.select2-search__field').trigger('input');
}

function setSearchElementHeight() {
    if ($(window).width() > 576) {

        $("body,html").animate({scrollTop: 0}, 500);

        const topOffset = $('.select2-results__options').offset().top;
        const scrollHeight = $('.select2-container').prop('scrollHeight');
        const viewHeight = $(window).height();
        const newHeight = viewHeight - topOffset - scrollHeight;

        $('.select2-results__options').css('max-height', newHeight);
    }
}

function closeSelect() {
    this.searchElement.select2("close");
}

export default {
    data,
    mounted,
    methods: {
        closeSelect2,
        bindSelect2ToStore,
        initSelect2,
        extractText,
        mobileFunctionalityLogic,
        createMyLocationField,
        onMyLocationSelected,
        getCurrentLocation,
        refreshSearchField,
        recoverFromLocationError,
        buildCurrentLocationPayload,
        buildLocationPayload,
        setSearchElementHeight,
        clearSearch,
        fillResults,
        mountMobileLogicComponentToSearch,
        setSearchInputTextOnMobile,
        closeSelect,
    },
    computed: {
        ...mapState([
            'translate',
            'location',
            'price',
            'features',
            'services',
            'category',
            'priceTemp',
            'featuresTemp',
            'servicesTemp',
            'categoryTemp',
            'searchResponse',
            'allServices',
            'locationTemp',
            'searchScrollPosition',
            'searchRadius',
            'searchRadiusTemp',
            'similarEscorts',
        ]),
    },
    components: {
        IconComponent,
    },
    watch: {
        translate() {
            this.initSelect2();
        }
    },

    beforeDestroy() {
        this.closeSelect();
    },
}
